/* Customized to use dlr-internet image component.
 * Shadow based on volto-logos-block 2.0.0.
 */

import React from 'react';
import { UniversalLink } from '@plone/volto/components';
import { Message } from 'semantic-ui-react';
import { defineMessages, useIntl } from 'react-intl';
import config from '@plone/volto/registry';
import imageBlockSVG from '@plone/volto/components/manage/Blocks/Image/block-image.svg';
import { PreviewImg } from 'volto-dlr/helpers';

const messages = defineMessages({
  PleaseChooseLogo: {
    id: 'Please choose a logo as source for this element',
    defaultMessage: 'Please choose a logo as source for this element',
  },
});

const View = (props) => {
  const { data, isEditMode } = props;
  const intl = useIntl();
  const logo = data.logo?.[0];

  const image = (
    <PreviewImg
      previewImage={logo}
      scaleName="teaser"
      alt="logo"
      className="logo-image"
    />
  );

  return (
    <div className="logo-block">
      {!logo && props.isEditMode && (
        <Message>
          <div className="grid-teaser-item default">
            <img src={imageBlockSVG} alt="" />
            <p>{intl.formatMessage(messages.PleaseChooseLogo)}</p>
          </div>
        </Message>
      )}
      {logo &&
        (isEditMode || !data.href?.length > 0 ? (
          image
        ) : (
          <UniversalLink href={data.href?.[0]?.['@id']}>{image}</UniversalLink>
        ))}
      {data.heading && (
        <h3 className="logo-heading headline">{data.heading}</h3>
      )}
      {config.blocks.blocksConfig.logo.showDescriptionField &&
        data.description && <p>{data.description}</p>}
    </div>
  );
};

export default View;
